module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('big', [_vm._v("B")]), _vm._v("rother Gabriel surveyed the hunched tenements languishing along Bankside Street. After the conference at Lambeth Palace was ended, he had not meant to return this way, back through Southwark and Bankside. And yet memory drew him to it. Memory or his dissatisfaction at the way the conference had gone. He needed a reminder of where he’d come from, what he’d been before Brother Francis saved him.")], 1), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He had thought his future settled. Father, Brother: those callings he embraced. When he’d received the commission to sell the papal indulgences, he’d been less enthusiastic, especially when it seemed this service to his church preempted the other two. Now his archbishop had decreed he was to add spy to his calling. But whence came that calling? Yet to question that would be to question the very institution that had brought him the means of salvation. It was still the only means as far as he could tell.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Was it still there? The brothel? Where his mother, little more than a girl herself, had plied her trade? A whore’s apprentice at twelve, whore at fourteen, mother at sixteen. He’d proved a stubborn fetus that would not turn loose even with the scraping of a knotted rope. “Marked by God,” Brother Francis had said, “a child protected in the womb to do His work.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Yet he hung on to the thinnest thread of belief that she had loved him. The brothel that kept her was more generous than some, giving her a halfday every month for herself. Every month she had made the five-mile trek to the priory to visit him. Every month she had brought him sweets and together they had played at toss the ball in the abbey gardens. And every month at leaving time, she had crushed him to her, his face pressed between the cleavage in her breasts, suffocating him with her musky sweat and woman smells, overlaid with stale perfume, attar of roses, provided by the house, the cost deducted from her wages.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“My pretty blond cherub,” she’d called him. “My sweet Gabriel.” Every month. For two years. The last time—he had not known it would be the last, how different might have been his demeanor if he had—her eyes had glittered with wetness, her arms resting on her high round belly. He’d known what that meant. And he’d been ashamed for her. Ashamed for himself. And when she’d tried to hug him good-bye, he’d pulled away, refusing to look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She had not come again.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Now, as he looked down the street, he tried to pick out the house he remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("There. The one with the rotting gable—no, it was too narrow. The one leaning into the street? No, it had no wide window. He remembered a wide window seat where he’d been allowed to play as a child. But only in the daytime. At night, he’d had to sleep in a small closet. From that tight, dark place, he sometimes heard his mother moan or cry out, and he’d been afraid for her. Afraid for himself. But she had told him never to leave the closet until she opened the door. He never did.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("His horse picked its way gingerly. The whole of Southwark was a field of stinking mud. Never mind that it had not rained for days and the heat wave lingered long past its welcome. Dead fish and the rotting carcass on the quayside added pungency to the air.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He was thinking he should definitely have taken the ferry when he saw the house.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A surge of recognition. A flash of memory. His heart beat the tat-tat rhythm of that small boy shut up in the closet. He should leave, right now, and let this place stay forever buried in its slag heap of regret and shame.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He got down from his horse.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("A youth of about twelve leaned against the portal, picking at scabs on his arm, an employee, perhaps, or a product of the house, some knight’s son or even the by-blow of the lord mayor himself—who would ever know? Certainly not the boy who reached for the reins. Himself at twelve, Brother Gabriel thought, except for the grace of God. And Brother Francis.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“This way, Father.” The boy opened the door and stepped away with a smirk on his face that only half registered. “Just ring the bell to let ’er know yer here.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Brother Gabriel lifted his hand to clang the little bell. Its clapper hung beneath the bell-shaped skirt of a woman painted obscenely in the costume of a whore. Its tinny sound echoed pitifully in the empty hallway. A familiar sound. A familiar place.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The narrow entry, the low ceiling that opened on the left into the crowded little sitting room, closed in around him. He’d played in that sitting room in the daytime, with his hands galloping a toy horse across the cold floor. It still looked the same. Watery light filtered through the large grimy window fronting on the street. And it still smelled the same: some yeasty, musty odor he could not name, and stale wine, and dead coals—for no matter how cold and gloomy the day, they only lit the fire and the lamps at night.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Come in, Father. My name is Mary. After our Lord’s mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The profanity of it nearly took his breath.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I can take away that frown,” the woman said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The fading bruise on her neck, he wondered, was that a souvenir left by her last customer? Her gaze traveled down his clerics’ robes and back up. She offered him a smirk in welcome and ran her fingers self-consciously through her hair, tossing her head, arching her back. Her nipples showed through her thin bodice.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“The younger ones are all still abed.” A little half-laugh. “Sleeping. It is early for us. Most of our customers come at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her gap-toothed smile might once have been pretty. Hard to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What I lack in youth, I can make up in experience. I’ve learned a trick or two that is certain sure to give ye pleasure.” Then she added, dropping her eyelids, reaching for his hand, “And I can be discreet.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Had experience taught her that his Dominican robes rendered no protection from her flesh-peddling? They rendered him little protection either, he thought, as he felt an unwelcome tightening in his loins. He clasped his hands together to stop her from touching him—and to stop their trembling. His body’s treacherous response to the woman’s lewd promise sickened him.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You misunderstand,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("It was hard to tell her age, but for all her worn-out appearance, he guessed her to be no older than he was. A woman still in her thirties. Not old enough to be his mother.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I’ve come on another matter altogether,” he said, sounding pompous, self-righteous even to his own ears. “I’m inquiring—for a parishioner— whether you have a girl … a woman … who lives here by the name of Jane. Jane Paul.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Jane, is it? Well, I’ll be Jane, Father, if ye’re partial to Janes.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("This time, it was his heart that betrayed him. The desperation in her sunken eyes, the longing, touched him, evoking more compassion than he should probably feel for one who embraced sin so willingly.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“There’s no one here by that name.” Her face went hard, her tone flat.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She turned her back on him and retreated up the stairs, her posture rigid, her steps careful as though she could summon dignity with her will. A flood of relief washed over him, weakening him in the knees. What foolishness had prompted him to inquire here? He heard the sharp slam of a door. What would he have said, what have done, if the woman had said she knew his mother, given him an address? Or worse yet, said Jane Paul was sleeping abovestairs at that very moment?")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The boy handed him the reins to his horse. “Are you all right, Father? You look poorly.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Unable to speak for the tightness of his throat, he shunted the boy off with a nod, and mounting his horse, rode away hastily lest he embarrass himself by vomiting in the street.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Only after he’d made good his escape, did he think about the boy. He should have given him something, still could. He hesitated. But he could not bring himself to go back.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Let him sleep.” The familiar voice came from a figure silhouetted in the doorway.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Come in. I was just going to wake my grandfather.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Jerome ducked under the lintel post, stepped just inside the door. “Let him sleep. Time enough for bad tidings when he wakes. I came to tell you there will be no meeting tonight.” His face looked grim.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No meeting? Is Martin not coming either?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She felt her face color at the transparency of her question. Of course Martin would not be coming if the others weren’t. But the old man did not notice. Or he let it pass.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No, Anna. Martin’s not coming. He’s been arrested along with Stasek and Jan.”")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No. Jan from the trivium. I fear all his learning in rhetoric and dialectic has gotten him in trouble. But Jan Hus will be next. The bishops are going after the small fry first. I blame myself for this.” He had taken off his hat in the heat and was twisting it in his hands. “I should never have brought the Wycliffe works from Oxford.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No, Master Jerome. It’s not your fault. You were only doing what you thought was right. And you weren’t the only one who brought them.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her mind was whirling as she tried to reassure him. Would her grandfather be next? Surely they would not disturb an old man who only studied the Bible in his own home. There was the prohibition, surely enough, but everybody read the vernacular Bible. The edict was openly defied. But the Lollard texts, the Wycliffe translations, these would be harder to explain away.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What did they do to give the bishop cause? Has he found out about the meetings?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Jerome shook his head in exasperation. “The brash young fools attended Sunday mass at Týn Church and burned the indulgences on the altar! The archbishop’s spies were there. As always.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“The indulgences! But I thought you took them.”")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Jan Hus is trying to get them out,” Jerome said. “He’s facing off with Zybnek now. But it will end badly. Even King Wenceslas is under pressure. He’s always been tolerant, but it’s hard when the crown gets a portion of the license money from the sale of the indulgences.”")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna had resolutely refused to think of her future without him, but as he leaned on the carved wooden balustrade of the stair, the specter of the little town house in Staroměstké náměstí after he was gone flashed across her consciousness. The sweat trickling at her hairline turned icy. He’d been all she’d ever known. Father. Mother. Sister. Brother. This old man and his passion for his work had illumined her life.")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She went over to him, offered him her arm. He shook it off gently but with a frown.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“What will end badly?” he asked.")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Your supper is ready. Master Jerome, your wife won’t mind if you eat with us, will she? To keep us company?” she implored him with a lift of her eyebrow.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her grandfather held the edge of the table for support as he lowered himself to the bench. “What about Martin? Is he not coming?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna ladled the fragrant stew onto the plates.")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Anna slept fitfully. After Jerome left, her grandfather had been seized with a paroxysm of coughing. He sometimes had a spell after working long hours with his paints and inks, but this time the phlegm he finally hawked from his wheezing lungs was the color of ditch water. Anna had dosed him with tincture of horehound and honey and distilled spirits, and finally, after assuring herself that his brow was cool, she banked the cook fire and went off to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("But it was a hot night. She lay awake, listening to night sounds drifting through her open window: the occasional creak of wooden wheels on cobblestone, the call of an owl to its mate, the distant sound of the cloister bells calling the cathedral monks to vigils. Listening too for the rattling cough. She threw off her coverlet, wondering if Martin was shut in some airless cell, wondering if he was afraid—or worse, being tortured in the castle dungeon. Just before dawn, she drifted off to troubled sleep.")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Her world was back in place with the morning light. She would probably hear soon that Martin and the others had been released with a warning.")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You should have called me,” Anna said.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Anna,” he said, frowning. “The milkmaid says they have arrested some students for breaking up Sunday services.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I know, but it will be all right. That was yesterday. Master Hus has probably already gotten them released by now.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“You should have told me,” he said over his shoulder as he counted out pennies to the woman. He shut the door behind her, turned to Anna, frowning. “Did you know Martin was among them?”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She reached for her apron hanging on a peg beside the hearth, swung the water pot around, avoiding his gaze. “Master Jerome told me last night. I wanted you to sleep well. I was going to tell you this morning. Don’t fret. This is not the first time they’ve gotten themselves in hot ashes.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He slumped down at his workbench, idly fingered the brushes neatly arranged in the drying rack he’d made for them. Anna watched him anxiously. This was just the kind of worry an old man didn’t need.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Never mind the porridge,” he said. “I have no appetite this morning. I want you to go across the square to the town hall and find out what you can. And if they’ve already been released, then go to the university and find Martin. I want to talk to him.” He was suddenly seized with a fit of coughing that rattled his whole body.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I don’t want to leave you.” She put the back of her hand to his brow. “You have a fever. Come. Let me help you back to bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He shook off her hand. “Anna, do as I say!”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The only time he had used that gruff tone with her, even as a child, was when she played too close to the fire or dabbled with his paints without permission.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She had never directly disobeyed him. Not as a child. Not as a woman. Was this the time to start?")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He shook his head. “It’s cooler down here.” The coughing had left his voice raspy. “I’ll just sit in my chair and wait. Leave the door open so I can watch you go.” He motioned to the deep cushioned chair that he’d tied together out of bent willow and leather strips.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("She retrieved a feather pillow for his head, cracked an egg and stirred it with a stick of cinnamon into a glass of milk and honey.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Drink this and I’ll go.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When he was settled into the chair, she handed him the drink. He frowned down at it then took a swallow or two.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Drink it all. You need it. Besides, the milk will sour quickly in this heat.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“I will drink it,” he said. “Now go.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna stepped out into the sunlit square. The air was thick. She could feel the hot cobblestones through her thin leather soles.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The hand of the great clock showed half past seven and already the heat was rising.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter05"
    }
  }), _vm._v("FIVE")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "46",
      "src": "images/flower1.jpg",
      "width": "160"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "normal5a"
  }, [_c('em', [_vm._v("[An indulgence is] the remission of the temporal penalty due to forgiven sin, in virtue of the merits of"), _c('br'), _vm._v("Christ and the saints")]), _vm._v("."), _c('br'), _vm._v("—"), _c('em', [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XFORD")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICTIONARY OF THE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HURCH")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He left his reverie of self-doubt—for that must surely be its name; he could never doubt his church—to consider his surroundings from astride the "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("horse that same church provided. It was as though this place, these smells, these sounds of cursing and bear-baiting and bargaining, echoed some half-forgotten dream rather than his own childhood memories. He’d been six years old when Brother Francis rescued him from the cesspit that was Southwark.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("The day Brother Francis had taken him away his mother had cried, but that occasion for her grief had proved his salvation and his singular good fortune. He, the bastard son of a harlot, had been to Rome, had kissed the ring of the pope. Brother Gabriel was a man marked for greatness. Brother Francis had said so. More than once. So it must be true.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The closeness was too much. His heart skittered against his chest wall. Hearing the sound of a door opening abovestairs, he turned to flee. Then the "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("fragrance of attar of roses came back to him as though memory had materialized at his side. But it was no memory that flounced down the stairs to greet him.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Another time, perhaps,” he said, cursing himself for a coward because he’d let compassion overrule the reputation of the clergy. He tried to smile at "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("the woman. And then let it fade. She would only take it for encouragement, not compassion. “Today, I need to find a woman named Jane Paul,” he said, clearing his throat.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/flower.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "normal"
  }, [_vm._v("From the open door, Anna kept one eye on the astronomical clock as she laid the table with pewter plates and bread and cheese and grapes. The pigeon stew in the earthenware pot buried in the embers should be falling off the bone by now. She had put it to bake before leaving for Judenstadt. Fifteen more minutes and the students would be here. The inkwells were filled, blank paper laid out for the copying, fresh quills, the Wycliffe Bible laid out for her grandfather to read from. As scholars from the university, most of them would pay close attention to the English, and then Jerome would read Jan Hus’s translation. She should wake D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek, see that he was alert, then maybe she’d have time enough left to brush her hair and change her apron.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek, are you up from your nap? It’s almost time,” she shouted up the stairs.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("Jerome was early. There would be no time to refresh her hair and change her apron.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Arrested! Why?” But she knew why and her mind was whirling. "), _c('em', [_vm._v("Please, God, let him keep his mouth shut. Please, please let him not mention Finn the Illuminator")]), _vm._v(". “Jan Hus too?” she asked. If they’d taken Jan Hus, they must have damning evidence indeed!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Martin talked me into giving them back to him. He said that I should not "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("endanger my family by having them, that I was watched by the archbishop’s men. He promised to burn them.” He laughed bitterly. “Well, he burned them, all right.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Anna felt her heart rise into her throat. She could see Martin with his reckless, flashing eyes, haranguing. She’d heard him on the subject before. "), _c('em', [_vm._v("“The holy fathers peddle pardons as though they were the gatekeepers of hell itself. And that would make them the devil’s henchmen, then. Wouldn’t it”")]), _vm._v(" Foolishness to take his argument to such a public place. Why did they not let well enough alone! The people were going to Bethlehem Chapel anyway. Such rashness would give the Church the excuse they needed to act. Sweet, impatient Martin! He needed her almost as much as D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek. One too old to listen to reason and one too young to understand it. And she was caught between them.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Shuffling footfalls on the stair caused her to signal Jerome, a finger against her lips to shush him. If Hus could get the students released, D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek might never have to know. Her grandfather appeared at the bottom of the narrow wooden staircase, leaning against the casement for support. He looked frail, and his skin had a grayish cast.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek. Jerome has come to tell us we must postpone tonight’s meeting.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“Nothing. Just the usual. The archbishop and his threats.” She shook her head very slightly, catching Jerome’s gaze with her own, then busied herself "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("with taking up the stew, her face hidden from her grandfather lest he read the lie in her eyes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“No, D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek, Martin will not be coming tonight.”")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/flower.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("When she woke to the sound of the church bells tolling prime, the sun had already laid a saber of light across her counterpane. She hurriedly ran a comb through her tangled hair and bound it into its kerchief, then laced her bodice over yesterday’s shirt—no time to find a clean one—and threw on her kirtle. She rushed to D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek’s room, knocked softly, pushed open his door. His bed was empty. She smiled to see how neatly he had made it up. As always. His chamber so spare and tidy it made her own seem a riot of disorder.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek should not have let her sleep so late. He was probably making "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("his porridge for himself. But when she reached the bottom of the steps she found him standing at the door, hot sunlight pouring in around him. He was talking to the girl who sold them milk and eggs.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("He motioned impatiently with one hand for her to go, supporting his ribs with the other, the way he always did when he coughed—a habit born of his sojourn in Castle Prison. His body might be weak, but his spirit and his mind were as strong as ever. To defy him now would undermine that spirit, and then he would be truly old. The town hall was just across the square. She "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("could at least go there and see if the men were still being held. Maybe see Martin.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("“All right, D"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/e.jpg",
      "width": "8"
    }
  }), _vm._v("de"), _c('img', {
    attrs: {
      "alt": "image",
      "height": "12",
      "src": "images/c.jpg",
      "width": "7"
    }
  }), _vm._v("ek, I will go, but first let me help you back to bed.”")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18385f1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 93
// module chunks = 0